import { render, staticRenderFns } from "./PopUpImage.vue?vue&type=template&id=04d6b2ec&scoped=true"
import script from "./PopUpImage.vue?vue&type=script&lang=js"
export * from "./PopUpImage.vue?vue&type=script&lang=js"
import style0 from "./PopUpImage.vue?vue&type=style&index=0&id=04d6b2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d6b2ec",
  null
  
)

export default component.exports